/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {SafeResourceUrl} from "@angular/platform-browser";

export interface LoginRequest {
  username: string;
  password: string;
  grant_type : string;
}

export interface LoginResponse {
  access_token?: string;
  IsVerified?: boolean;
  UserName?: string;
  Roles?: string;
  Expiration?: Date;
  IssuedAt?: Date;

  error?: string
}

export class LoggedUser {

  public id: number | null = null;
  public name: string | null = null;
  public profileId : number | null = null;
  public profileIdEnc : string | null = null;
  public role: string | null = null;
  public dep: string | null = null;
  public line: string | null = null;
}

export class SignInRequest {
  username: string = '';
  password: string = '';
  remberMe : boolean = false;
}

export class ResetPassword {
  oldpassword: string = '';
  newpassword: string = '';
  email: string = '';
}

export class EmailResetPasswordDto{
  public Email : string | null = null;
  public IdAnagraficaUtente : number | null = null;
}


export class ChangePassword {
  email : string = '';
  code : string | null = null;
  password: string = '';
}

export class VerifyOtpRequest {
  email: string;
  code: string;

  constructor(email?: string, code?: string) {
    this.code = code ?? '';
    this.email = email ?? '';
  }
}
